import styled from 'styled-components';
import { animated } from 'react-spring';
import {
  typography,
  colors,
  size,
  Button as RawButton,
  Input as RawInput,
  mediaQueries,
} from '@everlywell/leaves';

export const Headline = styled.h3`
  ${typography.h3Text};
  align-self: flex-start;
  margin-top: ${size.xl2}px;
  margin-bottom: ${size.sm}px;
  ${mediaQueries.forTabletHorizontalUp} {
    font-size: 1.9rem;
  }
`;

export const DisclaimerTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-bottom: ${size.xl2}px;
  }
`;

export const HeadlineImage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 224px;
  height: 224px;
`;

export const P = styled.p`
  ${typography.bodyTextSmall}
  margin-bottom: ${size.lg}px;

  a {
    ${typography.buttonTextSmall};
    text-decoration: none;
    cursor: pointer;
  }
`;

export const ListHeading = styled.p`
  ${typography.bodyTextSmall}
`;

export const UL = styled.ul`
  list-style: none;
  margin-bottom: ${size.lg}px;
`;

export const LI = styled.li`
  ${typography.bodyTextSmall}
  position: relative;
  padding-left: ${size.md}px;
  &:before {
    position: absolute;
    left: 0;
    top: ${size.xs1}px;
    content: '';
    display: inline-block;
    border-radius: 50%;
    width: 4px;
    height: 4px;
    background-color: ${colors.teal6};
    margin-right: ${size.xs1}px;
  }
`;

export const GetStartedButton = styled(RawButton).attrs(props => ({
  onClick: props.onClick,
}))`
  margin: ${size.md}px auto ${size.lg}px;
  width: 100%;
  max-width: 327px;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const QuestionCount = styled.div`
  ${typography.overlineText}
  margin-top: ${size.md}px;
  align-self: flex-start;
`;

export const Question = styled.div`
  ${typography.displayText};
  margin-top: ${size.sm}px;
`;

export const Fieldset = styled.fieldset`
  margin-top: ${size.xl1}px;
`;

export const Legend = styled.legend`
  position: absolute;
  opacity: 0;
  z-index: -1;
`;

export const OptionTitle = styled.div`
  ${typography.buttonText};
  color: ${colors.green5};
`;

export const RadioOptionHeading = styled.div`
  border-radius: 2px 2px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${size.sm}px ${size.sm}px ${size.sm}px ${size.lg}px;
  background-color: ${colors.green1};
  border: 1px solid ${colors.green2};
  color: ${colors.green3};
`;

export const RadioOption = styled.div`
  border: 1px solid ${colors.green2};
  border-radius: 2px;
  box-shadow: 0 7px 30px -10px #dce4e5;
  margin-bottom: ${size.xl2}px;
  cursor: pointer;
  transition: all 0.15s ease-in-out;

  &:hover,
  &:focus {
    border: 1px solid ${colors.green3};

    ${RadioOptionHeading} {
      background-color: ${colors.green2};
      color: ${colors.green5};
    }
  }
`;

export const RadioOptionContent = styled.div`
  padding: ${size.md}px ${size.lg}px;

  ${UL} {
    margin-bottom: 0;
  }

  ${LI} {
    ${typography.bodyTextXSmall};
    margin-bottom: ${size.sm}px;
    line-height: 22px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const Text = styled.p`
  ${typography.bodyTextXSmall};
  line-height: 22px;
`;

export const Heading = styled.div`
  ${typography.displayText};
  margin-top: ${size.lg}px;
`;

export const ContentInner = styled.div`
  margin-top: ${size.xs1}px;
  padding-bottom: ${size.xl1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-bottom: 0;
  }

  ${P} {
    margin-bottom: ${size.md}px;
  }

  ${LI} {
    margin-bottom: ${size.md}px;
  }
`;

export const SignUpHeading = styled(Heading)`
  margin-top: ${size.xl3}px;
  margin-bottom: ${size.xs1}px;
`;

export const EligibleContent = styled.div`
  ${typography.h4Text};
  align-items: center;
  display: block;
  padding-top: 200px;
  height: 100%;

  ${mediaQueries.forTabletHorizontalUp} {
    text-align: center;
    padding: 300px 0;
  }
`;

export const Label = styled.label`
  position: absolute;
  opacity: 0;
`;

export const EmailInput = styled(RawInput)`
  margin-right: ${size.md}px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  padding-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletVerticalUp} {
    flex-direction: row;
  }
`;

// TODO: allow import of button styles from DLS so we can apply to other elements like an input
export const SubmitInput = styled.input`
  -webkit-appearance: none;
  padding: ${size.sm}px ${size.lg}px;
  font-family: ${typography.type.nexa};
  font-size: 18px;
  font-weight: ${typography.weight.bold};
  border: 1px solid ${colors.green5};
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  display: inline-block;
  line-height: 22px;
  text-decoration: none;
  text-align: center;
  color: ${colors.white};
  background-color: ${colors.green5};
  width: 195px;
  box-shadow: 0 2px 15px -5px rgba(0, 0, 0, 0.12);
  max-height: 48px;

  &:hover,
  &:focus {
    background-color: ${colors.green4};
    border-color: ${colors.green4};
    outline: none;
  }

  &:active {
    background-color: ${colors.green5};
    border-color: ${colors.green5};
  }
`;

export const ContentWrapper = styled.div`
  padding-bottom: ${size.xl1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-bottom: 0;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  border-radius: 3px;
  background-color: ${colors.green2};
  margin-top: ${size.xl1}px;
`;

export const Inner = styled(animated.div)`
  background-color: ${colors.green5};
  height: 6px;
  border-radius: 3px;
`;
